const environment = "production";

let config = {};

switch (environment) {
  case "local":
    config = {
      clientBaseUrl: "http://localhost:3000",
      serverBaseUrl: "http://localhost:8030",
    };
    break;

  case "development":
    config = {
      clientBaseUrl: "https://projects.dev.ebs.ee",
      serverBaseUrl: "https://projects.dev.ebs.ee",
    };
    break;

  case "production":
    config = {
      clientBaseUrl: "https://projects.ebs.ee",
      serverBaseUrl: "https://projects.ebs.ee",
    };
    break;

  default:
    throw new Error(`Unknown environment: ${environment}`);
}

module.exports = config;
